import { SimpleModalTW } from '../../../../tailwindComponents/modals/SimpleModalTW';
import React, { useState } from 'react';
import { HeaderText2TW } from '../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { SimpleToggleTW } from '../../../../tailwindComponents/toggleTW/SimpleToggleTW';
import { CreateExistingPartySignerForm } from './CreateExistingPartySignerForm';
import { CreateNewSignerForm } from './CreateNewSignerForm';
import { ISigningAppointmentEditFormData } from '../../../../types/signingAppointment/ISigningAppointmentEditFormData';
import { useSelectAppointmentFromPathParam } from '../../../../utilities/order/scheduling/useSomeAppointmentFromParam';

export interface CreateSignerModalProps {
  show: boolean;
  onClose: () => void;
  onSaveEditions: (formData: ISigningAppointmentEditFormData) => Promise<void>;
}

export const CreateSignerModal = ({ show, onClose, onSaveEditions }: CreateSignerModalProps) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();

  const [isExistingContact, setIsExistingContact] = useState<boolean>(true);

  const onToggleChange = () => {
    setIsExistingContact((prev) => !prev);
  };

  if (!appointmentFromPath) {
    return null;
  }
  return (
    <SimpleModalTW open={show} setOpen={onClose}>
      <div className={'min-w-full'}>
        <section className={'mb-4'}>
          <HeaderText2TW>Create a Signer</HeaderText2TW>
        </section>

        <section>
          <div className={'mb-4'}>
            <SimpleToggleTW onChange={onToggleChange} text={'Select Existing'} checked={isExistingContact} />
          </div>
          <section>
            {isExistingContact ? (
              <CreateExistingPartySignerForm onCreate={onClose} onSaveEditions={onSaveEditions} />
            ) : (
              <CreateNewSignerForm onCreate={onClose} onSaveEditions={onSaveEditions} />
            )}
          </section>
        </section>
      </div>
    </SimpleModalTW>
  );
};
